import * as React from 'react';
import * as mobxReact from 'mobx-react';
import * as IoC from 'typescript-ioc';
import ReactDOM from 'react-dom';
import { ISubWindowsService } from '../../../infrastructure/sub-windows';
import { SubWindowsService } from '../../../infrastructure/implementations/sub-window';
import { SubWindow } from './sub-window';
import { SubWindowsHostViewModel } from './sub-windows-host.viewmodel';
import './sub-window.scss';

const SubWindowsListPresentation = mobxReact.observer((props: { subWindowsWM: SubWindowsHostViewModel}) => {
    return <>
        {props.subWindowsWM.getActiveSubWindows().map(x => {
            return (
                <SubWindow
                    key={x.uid}
                    subWindowViewModel={x.subWindowContextData}
                />
            );
        })}
    </>;
});

interface IState {
    portalElement: HTMLDivElement;
    hostViewModel: SubWindowsHostViewModel;
}

/**
 * Component, which is hosting a bunch of sub-windows in the portal element, appended to document body.
 * Tightly coupled with SubWindowService.
 * Once mounted - pass it's viewmodel to SubWindowService instance, which indicates that this SubWindowHost become a newly active `scope`.
 * Once unmounted - deactivate it's viewmodel into SubWindowService,
 * which indicates that this SubWindowHost become deactivated and should not longer be used for showing new subwindows.
 */
class SubWindowsHost extends React.Component<{}, IState> {
    constructor(props, context) {
        super(props, context);

        this.state = {
            portalElement: null,
            hostViewModel: null,
        };
    }

    public componentDidMount(): void {
        const portalElement = document.createElement('div');
        portalElement.className = 'sub-windows-host';

        const hostViewModel = new SubWindowsHostViewModel();
        document.body.appendChild(portalElement);

        const subWindowsService = IoC.Container.get(ISubWindowsService) as SubWindowsService;

        subWindowsService.activateSubWindowsHost(hostViewModel);

        this.setState({
            portalElement: portalElement,
            hostViewModel: hostViewModel,
        });
    }

    public componentWillUnmount() {
        const subWindowsService = IoC.Container.get(ISubWindowsService) as SubWindowsService;

        subWindowsService.deactivateSubWindowsHost(this.state.hostViewModel);
        document.body.removeChild(this.state.portalElement);
    }

    public render() {
        return (
            <>
                {this.props.children}
                {this.state.portalElement && ReactDOM.createPortal(
                    <SubWindowsListPresentation subWindowsWM={this.state.hostViewModel} />,
                    this.state.portalElement)}
            </>
        );
    }
}

export { SubWindowsHost };